import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, Dropdown, MenuProps } from 'antd';

import TooltipsOption from '@totem/components/common/profileIcon/tooltipsOption';
import accountUtilities from '@totem/components/userContext/accountUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import colors from '@totem/styles/colors';

import './profileIcon.css';

interface AvatarProps {
  size: number | 'small' | 'large' | 'default';
  style: any;
  children?: any;
  src?: string;
}

const styles = {
  avatar: {
    backgroundColor: colors.neutral.dim,
  },
};

const ProfileIcon = () => {
  const navigate = useNavigate();
  const { userProfile } = useContext(UserProfileContext);
  const { logout: auth0Logout } = useAuth0();

  const navigateToLogin = () => {
    accountUtilities.logout();

    auth0Logout({ logoutParams: { returnTo: window.location.origin } });

    navigate('/login');
  };

  const navigateToUserProfile = () => {
    if (userProfile.organization.role === -2) {
      navigate('/tenant-dashboard/userProfile');
      return;
    }
    if (userProfile.organization.role === -1) {
      navigate('/vendor-dashboard/userProfile');
      return;
    }
    navigate('/dashboard/userProfile');
  };

  const navigateToMyWork = () => {
    navigate('/dashboard/myWork');
  };

  const isDefaultImage = userProfile
    ? userProfile.imageUrl.includes('cdn.auth0.com')
    : true;

  const initials = userProfile
    ? `${userProfile.firstName[0]}${userProfile.lastName[0]}`
    : 'NU';

  const avatarProps: AvatarProps = {
    size: 'large',
    style: styles.avatar,
    ...(isDefaultImage && { children: initials }),
    ...(!isDefaultImage && { src: userProfile.imageUrl }),
  };

  const items: MenuProps['items'] = [
    {
      key: 'user_profile',
      title: 'User Profile',
      label: 'User Profile',
    },
    {
      key: 'my_work',
      title: 'My Work',
      label: 'My Work',
    },
    {
      key: 'sign_out',
      title: 'Sign Out',
      label: 'Sign Out',
    },
    ...(userProfile.organization.role >= 3
      ? [
          {
            key: 'set_tooltips',
            title: 'Tooltips',
            label: <TooltipsOption />,
          },
        ]
      : []),
  ];

  const onMenuClicked = ({ key }) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'user_profile':
        navigateToUserProfile();
        break;
      case 'my_work':
        navigateToMyWork();
        break;
      case 'sign_out':
        navigateToLogin();
        break;
    }
  };

  return (
    <div styleName="container">
      <div styleName="avatar">
        <Dropdown
          menu={{ items, onClick: onMenuClicked }}
          trigger={['hover', 'click']}
          placement="bottomRight"
        >
          <Avatar {...avatarProps} />
        </Dropdown>
      </div>
    </div>
  );
};

export default ProfileIcon;
